import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../../../../models/base/base-view-model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ShelfTalkerCardData } from '../../../../../../models/shelf-talkers/shelf-talker-card-data';
import { map } from 'rxjs/operators';
import { exists } from '../../../../../../functions/exists';
import { ActivatedRoute } from '@angular/router';

@Injectable()
export class ShelfTalkerCardContentViewModel extends BaseViewModel {
  constructor(protected activatedRoute: ActivatedRoute) {
    super();
  }

  public viewingInLiveView$ = this.activatedRoute.url.pipe(
    map(segments => exists(segments?.find(segment => segment?.path === 'live-view')))
  );

  private readonly _data = new BehaviorSubject<ShelfTalkerCardData | null>(null);
  public readonly data$ = this._data as Observable<ShelfTalkerCardData | null>;
  connectToData = (data: ShelfTalkerCardData) => this._data.next(data || null);

  private readonly _preview = new BehaviorSubject<boolean>(false);
  public readonly preview$ = this._preview as Observable<boolean>;
  connectToPreview = (preview: boolean) => this._preview.next(preview);

  public readonly cardSize$ = this.data$.pipe(map(data => data?.section?.cardSize ?? null));
  public readonly headerText$ = this.data$.pipe(map(data => data?.getCardTitle() ?? ''));
  public readonly companyLogo$ = this.data$.pipe(map(data => data?.getCompanyLogo()));
}
